import * as ysCountDown from "../../components/yscountdown.min.js";

document.addEventListener('DOMContentLoaded', function() {
  // Set active link (need via js because we use caching for links)
  const site_params = new URLSearchParams(window.location.search);
  const params_key = 'category_id';
  if (site_params.has(params_key)) {
    $( ".categories-list a" ).each(function( index ) {
      const a_params = new URLSearchParams("?".concat($( this ).attr('href').split('?')[1]));
      if (a_params.has(params_key)) {
        if ( site_params.get(params_key) == a_params.get(params_key) ) {
          $( this ).addClass( "active" )
        }
      }
    });
  }

  var counterElement = document.querySelector("#counter");

  if (counterElement) {
    var endDate = new Date(parseInt(counterElement.dataset.date, 10));
    if (endDate.getTime() > new Date().getTime()) {
      new ysCountDown(endDate.toString(), function (remaining, finished) {
        var message = "";
        if (finished) {
          message = "--:--";
          window.location.replace(counterElement.dataset.redirectUrl);
        } else {
          message += remaining.minutes + " m ";
          message += remaining.seconds + " s ";
        }
        counterElement.textContent = message;
      });
    }
  }
})
